const privateMap = new WeakMap;

export default class GetPrivateData
{
	constructor(classConstructor)
	{
		if(privateMap.has(classConstructor))
		{
			throw new Error('The private data for this class has already been requested');
		}
		privateMap.set(classConstructor, new WeakMap);
		privateMap.set(this,classConstructor);
	}

	for(classInstance,initial)
	{
		const classMap = privateMap.get(privateMap.get(this));
		if(!classMap.has(classInstance))
		{
			initial = typeof initial === 'object' && initial || {};
			classMap.set(classInstance,initial);
		}
		return classMap.get(classInstance);
	}
}